import { IConfigResponse } from "../models/config/IConfig";
import { apiSlice } from "./apiSlice";

const ROUTE = "/config";

const configApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getConfig: builder.query<IConfigResponse, void>({
            query: () => `${ROUTE}/get-config`
        })
    })
});

export const { useGetConfigQuery } = configApiSlice;
